import { Splide } from '@splidejs/splide';

export function basicSlideshow(options = {}) {
  let splide = null;
  let splideEl = null;

  return {
    init() {
      splideEl = this.$refs.splideEl || this.$root;

      splide = new Splide(splideEl, options).mount();
    },

    // Alpine calls destroy() when the element leaves the DOM (e.g. an Unpoly
    // fragment swap). Splide binds a window resize listener for its responsive
    // breakpoints, so without this the instance leaks on every navigation.
    destroy() {
      splide?.destroy();
      splide = null;
    }
  };
}

export function testimonialsSlideshow() {
  let splide = null;
  let splideEl = null;

  return {
    init() {
      splideEl = this.$refs.splideEl || this.$root;

      splide = new Splide(splideEl, {
        type: 'loop',
        speed: 1600,
        pagination: false,
        perPage: 1,
        perMove: 1,
        gap: '.75rem',
        padding: { left: '1rem', right: '1rem' },
        mediaQuery: 'min',
        breakpoints: {
          640: {
            perPage: 2,
            gap: 'clamp(1.125rem, 0.054rem + 1.339vw, 1.5rem)',
            padding: { left: '0', right: '0' },
          },
          1024: {
            perPage: 3
          }
        }
      }).mount();
    },

    // See basicSlideshow.destroy() — release the Splide instance (and its window
    // resize listener) when the fragment is removed under full-nav.
    destroy() {
      splide?.destroy();
      splide = null;
    }
  };
}
